export default __webpack_public_path__ + "static/fG-c6899e4b56eb952afe391721e188339c.svg";